<template>
  <b-button
      rounded
      size="is-small"
      :icon-left="'map-search'"
      :type="'is-warning is-light'"
      @click="toggleMapView(type)"
      :label="toggleMapLabel(type)"
  >
  </b-button>
</template>

<script>
  import FilterWithIcon from "../UI/FilterWithIcon";
  import bookingMixin from "../../mixins/bookingMixin";

  export default {
    name: "ToggleMapViewForBookingResults",
    mixins: [bookingMixin],
    components:{
    },
    props:{
      type:{
        type: String,
        default: '',
      }
    },
  }
</script>

<style scoped>

</style>